import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import SummaryBloodGlocoseCountBox from 'components/common/SummaryBloodGlocoseCountBox';

export default function AbnormalBloodGlocoseBoxTable(props) {
  const {
    hash,
  } = props;
  return (
    <table>
      <tbody>
        <tr>

          <td>
            <div>
              <SummaryBloodGlocoseCountBox {...{ label: T('새벽'), ...hash['새벽'] }} />
            </div>
          </td>
          <td>
            <div>
              <SummaryBloodGlocoseCountBox {...{ label: T('오전'), ...hash['오전'] }} />
            </div>
          </td>
          <td>
            <div>
              <SummaryBloodGlocoseCountBox {...{ label: T('오후'), ...hash['오후'] }} />
            </div>
          </td>
          <td>
            <div>
              <SummaryBloodGlocoseCountBox {...{ label: T('저녁'), ...hash['저녁'] }} />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
